import { render, staticRenderFns } from "./transFeed.vue?vue&type=template&id=2110694b&scoped=true"
import script from "./transFeed.vue?vue&type=script&lang=js"
export * from "./transFeed.vue?vue&type=script&lang=js"
import style0 from "./transFeed.vue?vue&type=style&index=0&id=2110694b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2110694b",
  null
  
)

export default component.exports